export default "__VITE_ASSET__BduNrwPv__"